// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2zv1E","icon":"SortAdornment_icon__rA42Y","up":"SortAdornment_up__29T-H","down":"SortAdornment_down__1cyaV","active":"SortAdornment_active__juliL"};